<template>
  <div>
    <div class="header">
      <img src="../assets/logo.jpg" height="50"/>

      <div class="header__menu">
        <a @click.prevent="$i18n.locale = 'en'" href="#">EN</a>
      </div>
    </div>
    <div class="login-box">
      <div class="login-box__header">
        Exercise Participant Login
      </div>
      <div class="login-box__body">
        <form class="demo-ruleForm" @submit.prevent="connect">

          <div class="field">
            <div class="field__label">
              Your Unit Name
            </div>
            <div class="field__input" :class="errors['name'] && 'field__input--invalid'">
              <input v-model="form.name" @input="errors['name'] && check($event.target.value, 'name')" @blur="check($event.target.value, 'name')" :disabled="connecting">
              <div v-if="errors['name']" class="field__errors">
                <div class="field__error" v-for="error of errors['name']">{{error}}</div>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="field__label">
              CTC Server URL
            </div>
            <div class="field__input" :class="errors['host'] && 'field__input--invalid'">
              <input v-model="form.host" @input="errors['host'] && check($event.target.value, 'host')" @blur="check($event.target.value, 'host')" :disabled="connecting">
              <div v-if="errors['host']" class="field__errors">
                <div class="field__error" v-for="error of errors['host']">{{error}}</div>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="field__label">
              Exercise Code
            </div>
            <div class="field__input" :class="errors['code'] && 'field__input--invalid'">
              <input v-model="form.code" @input="errors['code'] && check($event.target.value, 'code')" @blur="check($event.target.value, 'code')" :disabled="connecting">
              <div v-if="errors['code']" class="field__errors">
                <div class="field__error" v-for="error of errors['code']">{{error}}</div>
              </div>
            </div>
          </div>
          <button class="submit_btn" type="primary" @click="connect" :disabled="connecting">Connect</button>
          <div v-if="error" class="field__error">{{error}}</div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import socket from '../socket';
import MSGS from '../serverMessagesTypes';
import auth from '../auth';
import {ref} from 'vue';
import Cookie from 'js-cookie';
import qs from 'query-string';
// import $ from 'jquery';
// import cookie from 'jquery.cookie';

function hostValidator(value) {

  let ValidIpAddressRegex = RegExp("^https?:\/\/(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:[0-9]+)?$");

  let ValidHostnameRegex = RegExp("^https?:\/\/([a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]\.)+[a-zA-Z]{2,}$");
  let ValidLocalhostRegex = RegExp("^https?:\/\/localhost(?::[0-9]{2,4})?$");

  if (ValidHostnameRegex.test(value) ||
    ValidIpAddressRegex.test(value) ||
    ValidLocalhostRegex.test(value)) {

    return true;
  } else {
    return false;
  }
}

export default {
  name: 'FormValidation',
  data: () => ({
    form: {
      name: null,
      host: 'https://ctc.simsushare.com',
      code: null,
    },
    connecting: false,
    errors: null,
    isErrors: false,
    socket: null,
    rules: {}
  }),

  created() {
  },
  setup(props, {emit}) {
    const params = qs.parse(window.location.search)
    // console.log({params});
    const form = ref({
      name: params.name || "",
      host: 'https://ctc.simsushare.com',
      code: params.code || "",
    });
    const connecting = ref(false);
    const errors = ref({});
    const isErrors = ref(false);
    const rules = ref({});
    const error = ref('');

    form.value.name = Cookie.get("form_name") || form.value.name;
    form.value.host = Cookie.get("form_host") || window.location.origin || form.value.host;

    const validators = {
      name: [
        {
          validator: (val) => !!val,
          message: 'Please enter your unit name for the exercise',
        },
        {
          validator: (val) => val && val.length >= 3,
          message: 'Length should be at least 3 characters',
        },
      ],
      host: [
        {
          validator: hostValidator,
          message: 'Invalid host. Valid examples: https://myhost.com http://localhost:3000',
        }
      ],
      code: [
        {
          validator: (val) => !!val,
          message: 'Please input exercise code',
        },
        {
          validator: (val) => val && val.length >= 3,
          message: 'Code length should more than 3 characters',
        },
      ]
    }

    function check(val, type) {
      errors.value[type] = validators[type].map(type_validator => type_validator.validator(val) ? '' : type_validator.message).filter(msg => !!msg);
      if (errors.value[type].length === 0) {
        delete errors.value[type];
      }
      error.value = '';
    }

    function changeHost(e) {
      if (e.target.value.slice(-1) === '/') {
        form.value.host = e.target.value.slice(0, -1);
      }
    }

    function bindSocketMessages() {
      socket.on(MSGS.AUTH_FAIL, res => {
        isErrors.value = true;

        errors.value = "I do not see an exercise with that code";
      });

      socket.on(MSGS.AUTH_OK, res => {
        socket.userId = res.id;
        emit('onSocketConnected', socket);
      });
    }

    function connect() {
      check(form.value.name, 'name');
      check(form.value.host, 'host');
      check(form.value.code, 'code');
      if (errors.value && Object.keys(errors.value).length >0) {
        console.log(errors.value)
        return
      }
      connecting.value = true;

      Cookie("form_name", form.value.name);
      Cookie("form_host", form.value.host);
      sessionStorage.setItem("name", form.value.name);

      auth.login(form.value.host, form.value.code, (err, data) => {
        if (!err && data) {
          emit('update', {token: data.token, host: form.value.host, code: form.value.code});
          socket.start(form.value.host, data.token, form.value.name, form.code);
          bindSocketMessages();

          socket.auth();
        }
        if (err) {
          isErrors.value = true;
          error.value = "I do not see an exercise with that code";
        }

        connecting.value = false;
      });
    }

    return {form, check, connecting, error, errors, isErrors, rules, changeHost, connect}
  },
}
</script>

<style lang="scss" scoped>
.login-box__header {
  font-size: 18px;
}

.login-box__body {
  padding: 40px 20px;
}
.field {
  display: flex;
  margin-bottom: 20px;

  &__label {
    flex: 0 0 150px;
    font-weight: 700;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    padding: 12px 12px 0 0;
    box-sizing: border-box;
  }

  &__input {
    width: 100%;

    input {
      background-color: #FFFFFF;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      box-sizing: border-box;
      color: #2f2f30;
      display: inline-block;
      font-size: 16px;
      font-weight: 700;
      height: 40px;
      line-height: 40px;
      outline: none;
      padding: 0 15px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }

    &--invalid input {
      border-color: red;
    }
  }

  &__errors {

  }

  &__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
  }
}

.submit_btn {
  color: #FFFFFF;
  background-color: #ffc235;
  cursor: pointer;
  font-weight: 700;
  border-radius: 5px;
  padding: 10px 20px;
  margin: 10px auto;
  display:block;
  font-size: 16px;
  width: 120px;
  text-align: center;
  border: none;
  margin-top: 40px;
  &:hover {
    background-color: #c3952d;
  }
}

</style>
